<template>
<div>
    <div v-for="item in items" :key="item" class="mt-5">
        <p>{{ item.name}}</p>
<p>{{ item.type.name }}</p>
        <div v-for="value in item.value" :key="value" >
            <img v-if="value.attribute.name==='photo'" :src="`https://ecommerce-api.kalkidan.net/${ value.value}`" alt="notfound"  >
            <p class="inline" v-if="value.attribute.name!=='photo' && value.attribute.name!=='Description'" >{{ value.attribute.name }}</p>
        <p class="inline" v-if="value.attribute.name!=='photo' && value.attribute.name!=='Description'" >{{ value.value }}</p>
        <!-- <p v-if="value.attribute.name==='photo'">{{ value.value }}</p> -->
        </div>

    </div>

    <!-- <img :src="`
https://ecommerce-api.kalkidan.net/${photoes}`" alt=""> -->

</div>
</template>

<script>
import { useEcommerceStore } from '@/stores/Ecommerce';
import { useRouter } from 'vue-router';
import axios from 'axios';

export default {
    data(){
return{
    items:[],
    values:[],
    photo:[],
    photoes:'',
}
    },
    mounted(){
   const EcommerceStore = useEcommerceStore();
   const router = useRouter();
   EcommerceStore.verifyLogin(router);
   this.fetchProducts();
   //this.fetchValues();

    },
    methods:{
       async fetchProducts(){
            const response = await axios.get('https://ecommerce-api.kalkidan.net/api/item')
            this.items = response.data.item
            this.items.filter((item)=>{

                this.photo = item.value
                this.photoes = this.items.map(item => `https://ecommerce-api.kalkidan.net/${item.value}`);
            })
            this.photo.filter((p)=>{
            this.photoes =p.value;
            })
            console.log('photoes',this.photoes)
            console.log('photo',this.photo)
            console.log('products',this.items)
        },
        // async fetchValues(){
        //     const response = await axios.get('https://ecommerce-api.kalkidan.net/api/value')
        //     this.values = response.data.values
        //     console.log('values',response.data.values)
        // }
    }

}
</script>

<style>

</style>
